import { render, staticRenderFns } from "./ManageFeatureFlags.vue?vue&type=template&id=a477b81a"
import script from "./ManageFeatureFlags.vue?vue&type=script&lang=js"
export * from "./ManageFeatureFlags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports